const LEGACY_NMEA_PREVIEW_LBIDS = new Set([
  "fcf73ee8-979b-11ef-91ac-02c1fe2db5a5",
  "aebb3679-9132-11ef-8b69-02c1fe2db5a5",
]);

export const isLegacyNMEAPreviewLogbook = (
  lbid?: string | null,
): boolean => LEGACY_NMEA_PREVIEW_LBIDS.has(String(lbid));
